import {checkCodes} from "./checkCodes";
import {redirectToLogin} from "../utils/redirectToLogin";

export function initPointsForm() {
    new PointsForm();
}

class PointsForm {
    static BLOCK_SIZE = 1;
    static TOTAL_BLOCKS = 9;
    static LIMIT_OF_FIELDS = 9;
    static MIN_CONFIDENCE = 0;
    static TOTAL_LENGTH = PointsForm.BLOCK_SIZE * PointsForm.TOTAL_BLOCKS;


    constructor() {
        this.stream = null;
        this.usingCam = false;
        this.torchOn = false;
        this.mediaEnviromentInit = false;
        this.pointsModalTriggers = [...document.querySelectorAll('.js-code-modal-trigger')];
        this.pointsModal = document.querySelector('#pointsModal');
        if(this.pointsModal ){
            this.company = this.pointsModal.dataset.company;
            this.initialOpen = this.pointsModal.dataset.open==="true";
            this.shopCode = this.pointsModal.dataset.shopCode;
            this.languageCode = this.pointsModal.dataset.languageCode;
            this.userId = this.pointsModal.dataset.userId;
            this.sid = this.pointsModal.dataset.sid;
            this.groupCode = this.pointsModal.dataset.groupCode;
            this.groupName = this.pointsModal.dataset.groupName;
            this.customerNo = this.pointsModal.dataset.customerNo;
            this.codeInputGroupTemplate = this.pointsModal.querySelector('#codeInputGroupTemplate');
            this.pointsManualForm = this.pointsModal.querySelector('#pointsManualForm');
            /**Media setup*/
            this.mediaPhotoCanvas = this.pointsModal.querySelector('.js-code-photo-canvas');
            this.mediaPhotoFile = this.pointsModal.querySelector('.js-media-photo-file');
            this.photoStatus = this.pointsModal.querySelector('#photoStatus');
            this.pointsPhotoForm = this.pointsModal.querySelector('#pointsPhotoForm');
            this.mediaPhotoContainer = this.pointsModal.querySelector('.js-code-form-photo');

            /**Camera setup*/
            this.mediaCameraControls = this.pointsModal.querySelector('.js-code-form-controls-camera-upload');
            this.mediaVideo = this.pointsModal.querySelector('.js-media-video');
            this.mediaScannerCanvas = this.pointsModal.querySelector('.js-code-media-canvas');
            /**Scanner setup*/
            this.mediaCameraStart = this.pointsModal.querySelector('.js-camera-start');
            this.mediaCameraSnap = this.pointsModal.querySelector('.js-camera-snap');
            this.mediaCameraStop = this.pointsModal.querySelector('.js-camera-stop');
            this.mediaCameraLight = this.pointsModal.querySelector('.js-camera-light');
            this.mediaControls = this.pointsModal.querySelector('.js-code-form-media-controls');
            this.mediaScannerForm = this.pointsModal.querySelector('#pointsScannerForm');
            this.mediaScannerContainer = this.pointsModal.querySelector('.js-code-form-scanner');
            this.scannerStatus = this.pointsModal.querySelector('#scannerStatus');

            /**Tabs setup*/
            this.tabs = [...this.pointsModal.querySelectorAll('.js-community-tab')];
            this.panels = [...this.pointsModal.querySelectorAll('.js-community-tab-panel')];
            if(this.initialOpen){
                $(this.pointsModal).modal("show");
            }
        }



        if (this.pointsModalTriggers.length > 0){
            this.pointsModalTriggers.forEach((pointsModalTrigger) => {
                pointsModalTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.userId !== "" && this.pointsModal) {
                        $(this.pointsModal).modal("show");
                    } else {
                        redirectToLogin();
                    }
                });
            })
            $(this.pointsModal).on('hidden.bs.modal', () => {
                this.stopStream();
            });
            $(this.pointsModal).on('shown.bs.modal', () => {
                const firstInput = this.pointsModal.querySelector("input, select, textarea");
                if (firstInput) {
                    firstInput.focus();
                    firstInput.select();
                }
                this.init();
            });
        } else {
            console.error('Modal or trigger not found');
        }
    }

    init() {
        this.initPanelManualForm();
        this.initTabs();
    }

    initPanelManualForm() {
        const codeInputGroupTemplateContent = this.codeInputGroupTemplate.content.firstElementChild.cloneNode(true);
        const formFields = this.pointsManualForm.querySelector('.js-manual-form-fields');
        formFields.innerHTML = "";
        formFields.appendChild(codeInputGroupTemplateContent);
        this.initInputs(this.pointsManualForm);
        this.setupPointsForm(this.pointsManualForm, () => this.initPanelManualForm(), true);
        this.addNewInputRow(this.pointsManualForm);
    }

    initPanelPhotoForm() {
        const formFields = this.pointsPhotoForm.querySelector('.js-manual-form-fields');
        const uploadLabel = this.mediaPhotoContainer.querySelector('.js-upload-text');
        formFields.innerHTML = "";
        uploadLabel.textContent = "Foto auswählen";
        this.hideElement(this.pointsPhotoForm);

        // ✅ Define the listener only once and reuse it
        if (!this._photoChangeListener) {
            this._photoChangeListener = (e) => {
                const formFields = this.pointsPhotoForm.querySelector('.js-manual-form-fields');
                const uploadLabel = this.mediaPhotoContainer.querySelector('.js-upload-text');
                const pointsHintCollected = this.pointsPhotoForm.querySelector(".js-hint-points-collected");
                const pointsHintFailed = this.pointsPhotoForm.querySelector(".js-hint-points-failed");
                this.hideElement(pointsHintCollected);
                this.hideElement(pointsHintFailed);
                this.hideElement(this.pointsPhotoForm);
                console.log(formFields);
                formFields.innerHTML = "";


                this.setupPointsForm(this.pointsPhotoForm, () => this.initPanelPhotoForm(), true);

                if (e.target.files?.[0]) {
                    uploadLabel.textContent = "Foto ändern";
                    this.handleFile(
                        e.target.files[0],
                        this.mediaPhotoCanvas,
                        this.pointsPhotoForm,
                        true,
                        this.photoStatus
                    );
                } else {
                    uploadLabel.textContent = "Foto auswählen";
                }
            };
        }

        // ✅ Ensure we don’t duplicate listeners
        this.mediaPhotoFile.removeEventListener('change', this._photoChangeListener);
        this.mediaPhotoFile.addEventListener('change', this._photoChangeListener);
    }


    initPanelScannerForm() {
        if (this.mediaEnviromentInit) return;
        this.mediaEnviromentInit = true;
        this.setupPointsForm(this.mediaScannerForm, () => this.initPanelScannerForm, true);
        this.hideElement(this.mediaScannerForm);
        this.hideElement(this.mediaPhotoCanvas);

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            this.showElement(this.mediaCameraStart);
            this.mediaCameraStart.addEventListener('click', async () => {
                try {
                    this.stopStream();
                    const constraints = {video: {facingMode: {ideal: 'environment'}}, audio: false};
                    this.stream = await navigator.mediaDevices.getUserMedia(constraints);
                    this.showElement(this.mediaVideo)
                    this.hideElement(this.mediaScannerCanvas);
                    this.hideElement(this.mediaControls);
                    this.showElement(this.mediaCameraControls);
                    this.mediaScannerCanvas.classList.remove('analyzed');
                    this.mediaScannerCanvas.classList.remove('analyzing');
                    this.mediaVideo.srcObject = this.stream;
                    await this.mediaVideo.play();
                    this.usingCam = true;
                    this.scannerStatus.textContent = 'Kamera aktiv. Richte den Kronkorken mittig aus.';
                    this.mediaCameraSnap.disabled = false;
                    this.mediaCameraStop.disabled = false;
                    this.mediaCameraStart.disabled = true;

                    this.mediaCameraLight.disabled = !this.supportsTorch();
                    this.mediaVideo.scrollIntoView({
                        behavior: 'smooth',
                        block: "start", inline: "nearest"
                    });

                    //     this.setupPointsForm(this.mediaScannerForm, this.initPanelScannerForm);

                } catch (err) {
                    this.scannerStatus.textContent = 'Kamera konnte nicht gestartet werden: ' + err.message;
                    console.error(err);
                }
            });
            this.mediaCameraSnap.addEventListener('click', async () => {
                if (!this.usingCam || !this.mediaVideo.videoWidth) return;
                this.scannerStatus.textContent = 'Foto aufnehmen…';
                const off = document.createElement('canvas');
                off.width = this.mediaVideo.videoWidth;
                off.height = this.mediaVideo.videoHeight;
                const octx = off.getContext('2d');
                octx.drawImage(this.mediaVideo, 0, 0);
                off.toBlob(async (blob) => {
                    if (!blob) return;
                    const fileFromCam = new File([blob], 'camera.jpg', {type: 'image/jpeg'});
                    await this.handleFile(fileFromCam, this.mediaScannerCanvas, this.mediaScannerForm, true, this.scannerStatus);
                }, 'image/jpeg', 0.95);
                this.stopStream();
            });
            this.mediaCameraLight.addEventListener('click', async () => {
                this.torchOn = !this.torchOn;
                await this.toggleTorch(this.torchOn);
                this.mediaCameraLight.textContent = this.torchOn ? '<i class="icon icon-bold" aria-hidden="true"></i>' : '<i class="icon icon-bold-slash" aria-hidden="true"></i>';
            });
            this.mediaCameraStop.addEventListener('click', () => this.stopCamera());
            window.addEventListener('pagehide', this.stopCamera);
            window.addEventListener('beforeunload', this.stopCamera);
        } else {
            this.stopCamera()
        }
    }

    stopStream() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
    }

    addNewInputRow(form, data = null) {

        const submitButton = form.querySelector('.js-check-manual-form-submit');
        const formFields = form.querySelector('.js-manual-form-fields');
        const existingCodeContainers = [...formFields.querySelectorAll('.js-code-container')];
        submitButton.disabled = true;

        const newRow = this.codeInputGroupTemplate.content.firstElementChild.cloneNode(true);
        const removeButton = newRow.querySelector(".js-remove");
        if (existingCodeContainers.length >= PointsForm.LIMIT_OF_FIELDS) {
            return;
        }
        if (newRow && data && data?.text && data?.text?.length === 9) {
            const inputs = newRow.querySelectorAll("input");
            newRow.classList.add('generated');
            const confidenceElement = newRow.querySelector(".js-confidence");
            if (confidenceElement) {
                //  confidenceElement.innerHTML = "<i class='icon icon-pa"data?.confidence+"%";
            }
            inputs.forEach((input, index) => {
                input.value = data.text[index];
            })
        }
        const appendedRow = formFields.appendChild(newRow);
        if (removeButton) {
            this.showElement(removeButton);
            removeButton.addEventListener("click", e => {
                e.preventDefault();
                appendedRow.remove();
                this.initInputs(form);
            })
        }

        this.initInputs(form);
    }


    initInputs(form) {
        const submitButton = form.querySelector('.js-check-manual-form-submit');
        const inputGroups = Array.from(form.querySelectorAll('.js-code-input-group'));
        inputGroups.forEach((inputGroup, inputGroupIndex) => {
            const inputs = Array.from(inputGroup.querySelectorAll('input'));
            inputs.forEach((input, inputIndex) => {
                // Remove any previous listeners first
                input.replaceWith(input.cloneNode(true));
            });
        });
        // Re-select inputs after replacing them
        const freshInputGroups = Array.from(form.querySelectorAll('.js-code-input-group'));

        freshInputGroups.forEach((inputGroup, inputGroupIndex) => {
            const inputs = Array.from(inputGroup.querySelectorAll('input'));
            inputs.forEach((input, inputIndex) => {

                const onInput = (e) => {
                    const value = input.value;
                    if (value.length > 0) {
                        input.value = value.slice(-1);
                        setTimeout(() => {
                            inputs[inputIndex + 1]?.focus();
                            inputs[inputIndex + 1]?.select();
                        }, 0);
                    }

                    const hasAllValues = inputs.every(input => input.value.trim() !== "");
                    if (hasAllValues) {
                        if (inputGroupIndex + 1 === freshInputGroups.length - 1) {
                            this.addNewInputRow(form);

                            const nextInputs = freshInputGroups[inputGroupIndex + 1]?.querySelectorAll('input');
                            if (nextInputs && nextInputs.length > 0) {
                                nextInputs[0].focus();
                                nextInputs[0].select();
                            }
                        }
                    }
                    if (inputGroupIndex + 1 === freshInputGroups.length) {
                        this.addNewInputRow(form);
                    }

                    this.toggleFormButton(form, submitButton);
                };

                const onKeyDown = (e) => {
                    if (e.key === "Backspace" && !input.value) {
                        e.preventDefault();
                        inputs[inputIndex - 1]?.focus();
                        inputs[inputIndex - 1]?.select();

                        this.toggleFormButton(form, submitButton);
                    }
                };
                const onFocus = () => {
                    const hasAllValues = inputs.every(input => input.value.trim() !== "");
                    if (hasAllValues) {
                        if (inputGroupIndex + 1 === freshInputGroups.length) {
                            this.addNewInputRow(form);
                        }
                    }

                }

                const onPaste = (e) => {
                    const text = (e.clipboardData || window.clipboardData)?.getData('text') || "";
                    // Drop separators so "ABC-DEF-GHI" and "ABC DEF GHI" paste like "ABCDEFGHI"
                    const chars = text.replace(/[\s-]+/g, "");
                    if (chars.length === 0) return;
                    e.preventDefault();
                    const groupIsEmpty = inputs.every(groupInput => groupInput.value === "");
                    this.fillCodes(form, inputGroupIndex, groupIsEmpty ? 0 : inputIndex, chars);
                };

                input.addEventListener("input", onInput);
                input.addEventListener("paste", onPaste);
                input.addEventListener("keydown", onKeyDown);
                input.addEventListener("focus", onFocus);
            });
        });
        this.toggleFormButton(form, submitButton);
    }

    /**
     * Spreads pasted characters over the single-character inputs, continuing in
     * the following rows (new rows are added on demand, up to LIMIT_OF_FIELDS).
     * The DOM is re-queried per character because addNewInputRow() -> initInputs()
     * replaces the input elements.
     */
    fillCodes(form, startGroupIndex, startInputIndex, chars) {
        let groupIndex = startGroupIndex;
        let inputIndex = startInputIndex;

        for (const char of chars) {
            let groups = form.querySelectorAll('.js-code-input-group');
            if (groupIndex >= groups.length) {
                this.addNewInputRow(form);
                groups = form.querySelectorAll('.js-code-input-group');
                if (groupIndex >= groups.length) break;
            }
            const inputs = groups[groupIndex].querySelectorAll('input');
            inputs[inputIndex].value = char;
            inputIndex++;
            if (inputIndex >= inputs.length) {
                groupIndex++;
                inputIndex = 0;
            }
        }

        let groups = form.querySelectorAll('.js-code-input-group');
        const lastInputs = groups[groups.length - 1].querySelectorAll('input');
        if ([...lastInputs].every(input => input.value !== "")) {
            this.addNewInputRow(form);
            groups = form.querySelectorAll('.js-code-input-group');
        }

        const focusGroup = groups[Math.min(groupIndex, groups.length - 1)];
        const focusInput = focusGroup.querySelectorAll('input')[groupIndex < groups.length ? inputIndex : 0];
        focusInput?.focus();
        this.toggleFormButton(form, form.querySelector('.js-check-manual-form-submit'));
    }

    toggleFormButton(form, submitButton) {
        const inputGroups = Array.from(form.querySelectorAll('.js-code-input-group'));
        let countEmptyGroups = 0;
        let countHasAllValuesGroups = 0;
        let countHasNotAllValuesGroups = 0;
        inputGroups.forEach((inputGroup, inputGroupIndex) => {
            const inputs = Array.from(inputGroup.querySelectorAll('input'));
            const allEmpty = Array.from(inputs).every(input => input.value.trim() === "");
            const hasAllValues = Array.from(inputs).every(input => input.value.trim() !== "");
            if (allEmpty) {
                countEmptyGroups++;
            }
            if (hasAllValues) {
                countHasAllValuesGroups++;
            }
            if (!allEmpty && !hasAllValues) {
                countHasNotAllValuesGroups++;
            }
        });
        if (inputGroups.length > 0) {
            submitButton.textContent = "Codes einlösen";
        } else {
            submitButton.textContent = "Code einlösen";

        }

        if (countHasAllValuesGroups > 0 && countHasNotAllValuesGroups === 0) {
            submitButton.disabled = false;
        } else {
            submitButton.disabled = true;
        }

    }

    setupPointsForm(pointsManualForm, callbackReset, showFormAfterSuccess = false) {
        const pointsHintCollected = pointsManualForm.querySelector(".js-hint-points-collected");
        const pointsHintFailed = pointsManualForm.querySelector(".js-hint-points-failed");
        //    this.hideElement(pointsHintCollected);
        //   this.hideElement(pointsHintFailed);
        if (pointsManualForm._submitListener) {
            pointsManualForm.removeEventListener('submit', pointsManualForm._submitListener);
        }
        pointsManualForm._submitListener = async (ev) => {
            ev.preventDefault();
            const inputGroups = pointsManualForm.querySelectorAll(".js-code-input-group");
            const submitButton = pointsManualForm.querySelector(".js-check-manual-form-submit");
            const resetButton = pointsManualForm.querySelector(".js-check-manual-form-reset");

            const lotteryToConfirm = pointsManualForm.querySelector("input[name=lottery_to_confirm]") ? pointsManualForm.querySelector("input[name=lottery_to_confirm]").value : false;
            const lotteryIsConfirmed = pointsManualForm.querySelector("input[name=confirm_lottery]") ? pointsManualForm.querySelector("input[name=confirm_lottery]").checked : false;


            this.hideElement(pointsHintCollected);
            this.hideElement(pointsHintFailed);
            this.hideElement(resetButton);
            this.showElement(submitButton);
            resetButton.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.hideElement(resetButton);
                this.showElement(submitButton);
                if (callbackReset) {
                    callbackReset();
                }
            })
            let pointsCollected = 0;
            let codesFailed = 0;
            for (const inputGroup of inputGroups) {
                const parent = inputGroup.parentElement;
                if (!parent) continue;

                const statusIcon = parent.querySelector('.js-code-input-group-status-icon');
                // this.showElement(statusElement)
                this.showElement(statusIcon)

                const inputs = inputGroup.querySelectorAll("input");
                const removeButton = parent.querySelector(".js-remove");
                if (removeButton) {
                    removeButton.remove();
                }
                // Make inputs readonly and build the code string in one pass
                let code = "";
                for (const input of inputs) {
                    code += input.value;
                    input.disabled = true;
                }
                parent.id = `result_${code}`;

                if (statusIcon) {
                    statusIcon.id = `resulticon_${code}`;
                }
                if (code.length === PointsForm.TOTAL_BLOCKS) {
                    const amount = await checkCodes(code, this.sid, this.languageCode, this.customerNo, this.shopCode, this.company,this.groupCode,this.groupName, lotteryToConfirm, lotteryIsConfirmed);
                    pointsCollected += parseInt(amount);
                    if (amount === 0) {
                        codesFailed++;
                    }
                } else {
                    parent.remove();
                }
                for (const input of inputs) {
                    code += input.value;
                    input.disabled = false;
                }
            }
            updatePointsInHeader();
            if (pointsCollected > 0) {
                pointsHintCollected.innerHTML = "Erhaltene Punkte:<strong>" + pointsCollected + "</strong>";
                this.showElement(pointsHintCollected);
                pointsHintCollected.scrollIntoView({
                    behavior: 'smooth',
                    block: "start", inline: "nearest"
                });
            }
            if (codesFailed > 0) {
                // pointsHintFailed.innerText="<strong>Einige Codes wurden nicht gefunden. Prüfe diese und löse sie erneut ein.</strong>";
                pointsHintFailed.innerHTML = "Einige Codes wurden nicht gefunden. Prüfe diese und löse sie erneut ein.";
                this.showElement(pointsHintFailed);
                this.hideElement(resetButton);
                this.showElement(submitButton);
            }else{
                this.hideElement(pointsHintFailed);
            }
            if (callbackReset, showFormAfterSuccess && pointsCollected > 0 && codesFailed === 0) {
                callbackReset();
            }
        };
        pointsManualForm.addEventListener('submit', pointsManualForm._submitListener);
    }

    initTabs() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Deactivate all tabs
                this.tabs.forEach(t => {
                    t.setAttribute("aria-selected", "false");
                    t.setAttribute("tabindex", "-1");
                });

                // Hide all panels
                this.panels.forEach(panel => panel.hidden = true);
                //   this.footers.forEach(panel => panel.hidden = true);

                // Activate clicked tab
                tab.setAttribute("aria-selected", "true");
                tab.setAttribute("tabindex", "0");

                // Show associated panel
                const panel = document.getElementById(tab.getAttribute("aria-controls"));
                if (panel) panel.hidden = false;

                // Callback when tab changes
                this.onTabChange(tab.id);
            });
        });
    }

    onTabChange(selectedTabId) {
        let form = this.pointsManualForm;
        this.stopStream();
        if (selectedTabId === "tab-manual-input") {
            form = this.pointsManualForm;
            this.initPanelManualForm();
        }
        if (selectedTabId === "tab-photo-input") {
            form = this.pointsPhotoForm;
            this.hideElement(this.mediaPhotoCanvas);
            this.mediaPhotoFile.value = "";
            this.initPanelPhotoForm();
        }
        if (selectedTabId === "tab-scanner-input") {
            form = this.mediaScannerForm;
            const formFields = form.querySelector('.js-manual-form-fields');
            formFields.innerHTML = "";
            this.hideElement(this.mediaScannerCanvas);
            this.initPanelScannerForm();
        }
        const pointsHintCollected = form.querySelector(".js-hint-points-collected");
        const pointsHintFailed = form.querySelector(".js-hint-points-failed");
        const resetButton = form.querySelector(".js-check-manual-form-reset");
        this.hideElement(pointsHintCollected);
        this.hideElement(pointsHintFailed);
        this.hideElement(resetButton);
    }

    stopCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach(t => t.stop());
            this.stream = null;
        }
        this.usingCam = false;
        this.mediaCameraStart.disabled = false;
        this.mediaCameraSnap.disabled = true;
        this.mediaCameraStop.disabled = true;
        this.mediaCameraLight.disabled = true;
        this.scannerStatus.textContent = '';
        this.mediaVideo.srcObject = null;
        this.showElement(this.mediaControls);
        this.hideElement(this.mediaVideo);
        this.hideElement(this.mediaCameraControls);
        if (this.torchOn) this.toggleTorch(false);
    }

    async handleFile(f, mediaCanvas, resultForm, showAfterResult = false, statusElement) {
        if (!f) return;
        this.stopCamera();
        this.showElement(mediaCanvas)
        mediaCanvas.classList.remove('analyzed');
        mediaCanvas.classList.remove('analyzing');

        const ctx = mediaCanvas.getContext('2d');

        const bmp = await createImageBitmap(f);
        const maxW = 1200, scale = bmp.width > maxW ? maxW / bmp.width : 1;
        mediaCanvas.width = Math.round(bmp.width * scale);
        mediaCanvas.height = Math.round(bmp.height * scale);
        ctx.clearRect(0, 0, mediaCanvas.width, mediaCanvas.height);
        ctx.drawImage(bmp, 0, 0, mediaCanvas.width, mediaCanvas.height);

        statusElement.textContent = 'Kronkorken werden gesucht…';
        const fd = new FormData();
        fd.append('image', f);
        let res;
        try {
            mediaCanvas.classList.add('analyzing');
            res = await fetch('/module/mysydeshop/b2c/ajax.php?function=ocr_scanner', {method: 'POST', body: fd});

        } catch (e) {
            statusElement.textContent = 'Scanfunktion ist aktuell leider nicht verfügbar. Bitte nutze die Code eingeben Funktion';
            console.log('Netzwerkfehler: ' + e.message);
            return;
        }
        if (!res.ok) {
            try {
                const errorJson = await res.json();
                const errorJsonBody = JSON.parse(errorJson.body);
                statusElement.textContent = 'Scanfunktion ist aktuell leider nicht verfügbar. Bitte nutze die Code eingeben Funktion';
                console.log(errorJsonBody.error);
            } catch {
                statusElement.textContent = 'Fehler: ' + (await res.text().catch(() => ''));
            }
            return;
        }
        const json = await res.json().catch(() => null);
        if (!json) {
            statusElement.textContent = 'Scanfunktion ist aktuell leider nicht verfügbar. Bitte nutze die Code eingeben Funktion';
            return;
        }
        let caps = (json.caps || []).filter(c =>
            Array.isArray(c.lines) && c.lines.length === 3 &&
            c.lines.every(s => /^[A-Z0-9]{3}$/.test((s || '').toUpperCase())) &&
            (typeof c.confidence !== 'number' || c.confidence >= PointsForm.MIN_CONFIDENCE)
        ).map(c => ({...c, text: c.lines.join(''), groups: c.lines.join(' ')}));

        caps.forEach((c, i) => {
            this.addNewInputRow(resultForm, c);

        });
        mediaCanvas.classList.add('analyzed');
        mediaCanvas.classList.remove('analyzing');
        statusElement.textContent = `Gefunden Kronkorken: ${caps.length}`;
        if (!caps.length) {
            this.addNewInputRow(resultForm);
        }
        if (showAfterResult) {
            this.showElement(resultForm);
            resultForm.scrollIntoView({
                behavior: 'smooth',
                block: "start", inline: "nearest"
            });
        }
    }

    num(v) {
        return (typeof v === 'number' && isFinite(v)) ? v.toFixed(3) : '—';
    }

    supportsTorch() {
        try {
            if (!this.stream) return false;
            const track = this.stream.getVideoTracks()[0];
            const caps = track.getCapabilities?.();
            return !!caps?.torch;
        } catch {
            return false;
        }
    }

    async toggleTorch(on) {
        try {
            if (!this.stream) return;
            const track = this.stream.getVideoTracks()[0];
            const caps = track.getCapabilities?.();
            if (caps?.torch) await track.applyConstraints({advanced: [{torch: !!on}]});
        } catch (e) {
            console.debug('Torch not supported', e);
        }
    }

    hideElement(el) {
        el.style.display = "none";
    }

    showElement(el) {
        el.style.removeProperty("display");
    }
}